import type { SupabaseClient, User } from '@supabase/supabase-js';
import { resolveDisplayName } from '@/lib/auth/display-name';

/** Copy auth metadata into user_profiles when full_name is missing. */
export async function syncProfileNameFromUser(supabase: SupabaseClient, user: User): Promise<void> {
  const { data: profile } = await supabase
    .from('user_profiles')
    .select('full_name, institution_name, role')
    .eq('id', user.id)
    .maybeSingle();

  if (!profile) return;

  const isInstitution = profile.role === 'institution';
  const resolved = resolveDisplayName(profile, user, { institution: isInstitution });
  const current = isInstitution
    ? profile.institution_name?.trim() || profile.full_name?.trim()
    : profile.full_name?.trim();

  if (current && current !== 'Member') return;

  const patch: Record<string, string> = {};
  if (isInstitution && !profile.institution_name?.trim()) {
    patch.institution_name = resolved;
  }
  if (!profile.full_name?.trim()) {
    patch.full_name = resolved;
  }

  if (Object.keys(patch).length === 0) return;

  await supabase.from('user_profiles').update(patch).eq('id', user.id);
}
